export enum EnaioDeleteResultType {
    deleted = 0,
    notFound = 1,
    connectedToWorkflow = 2,
    hasDocuments = 3,
    failed = 4
}
export namespace EnaioDeleteResultType{
    export function getName(value: EnaioDeleteResultType): string {
        switch (value) {
            case EnaioDeleteResultType.deleted:
                return "deleted";
            case EnaioDeleteResultType.notFound:
                return "notFound";
            case EnaioDeleteResultType.connectedToWorkflow:
                return "connectedToWorkflow";
            case EnaioDeleteResultType.hasDocuments:
                return "hasDocuments";
            case EnaioDeleteResultType.failed:
                return "failed";
        }
    }
}
